import React from 'react';
import { Box, Loader, TextButton } from '@wix/design-system';
import { AnonymousFooter } from '../../../../Components/AnonymousFooter/AnonymousFooter';
import { AnonymousVoucherBanner } from '../../../../Components/VoucherBanner';
import { Recommendations, RecommendationsError } from '../../../../Components/Recommendations';
import BngDomainSuggestionsHeadingV2 from './BngDomainSuggestionsHeadingV2';
import BngDomainSuggestionsError from './BngDomainSuggestionsError';
import { BngDomainSuggestionsDataHooks } from './dataHooks';
import { useShowMoreDomainSuggestions } from './useShowMoreDomainSuggestions';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
export const BngDomainSuggestionsSectionV2 = _ref => {
  let headingRef = _ref.headingRef,
    recommendations = _ref.recommendations,
    isBusinessNamesReady = _ref.isBusinessNamesReady,
    isLoading = _ref.isLoading,
    isPricingLoading = _ref.isPricingLoading,
    hasMore = _ref.hasMore,
    fetchNextPage = _ref.fetchNextPage,
    isFetchingNextPage = _ref.isFetchingNextPage,
    hasFetchError = _ref.hasFetchError,
    onRetry = _ref.onRetry,
    searchTerm = _ref.searchTerm,
    taxesNotIncluded = _ref.taxesNotIncluded;
  const handleShowMore = useShowMoreDomainSuggestions({
    searchTerm,
    fetchNextPage
  });
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const isMobile = useIsMobile();
  const showEmptyState = !isLoading && recommendations.length === 0 && !hasFetchError;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4",
    width: "100%",
    paddingBottom: "20px",
    boxSizing: "border-box",
    dataHook: BngDomainSuggestionsDataHooks.domainSuggestionsSection
  }, !hasFetchError && /*#__PURE__*/React.createElement(BngDomainSuggestionsHeadingV2, {
    ref: headingRef,
    isLoading: !isBusinessNamesReady
  }), isMobile && /*#__PURE__*/React.createElement(AnonymousVoucherBanner, null), hasFetchError ? /*#__PURE__*/React.createElement(BngDomainSuggestionsError, {
    onRetry: onRetry
  }) : showEmptyState ? /*#__PURE__*/React.createElement(RecommendationsError, {
    error: "NoRecommendations",
    onRetry: onRetry,
    type: "anonymous",
    width: "100%"
  }) : /*#__PURE__*/React.createElement(Box, {
    borderRadius: "12px",
    border: "1px solid var(--wds-color-border-disabled, #e5e5e5)",
    backgroundColor: "var(--wds-color-fill-light-primary, #fff)"
  }, /*#__PURE__*/React.createElement(Recommendations, {
    recommendations: recommendations,
    isLoading: isLoading,
    isPricingLoading: isPricingLoading,
    hasMore: hasMore,
    fetchNextPage: handleShowMore,
    isFetchingNextPage: isFetchingNextPage,
    showHeroCard: false,
    useCompactRecommendationsLayout: true,
    bareListOnly: true,
    clickableRows: true,
    padding: "0"
  })), !showEmptyState && !hasFetchError && hasMore && /*#__PURE__*/React.createElement(Box, {
    paddingLeft: "SP3"
  }, /*#__PURE__*/React.createElement(TextButton, {
    skin: "dark",
    size: "small",
    weight: "bold",
    underline: "always",
    onClick: handleShowMore,
    suffixIcon: isFetchingNextPage ? /*#__PURE__*/React.createElement(Box, {
      marginLeft: "3px",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    })) : undefined
  }, t('domain_search_gate.results.show_more'))), !hasFetchError && recommendations.length > 0 && /*#__PURE__*/React.createElement(Box, {
    paddingLeft: "SP3"
  }, /*#__PURE__*/React.createElement(AnonymousFooter, {
    taxesNotIncluded: taxesNotIncluded
  })));
};
//# sourceMappingURL=BngDomainSuggestionsSectionV2.js.map